export default __webpack_public_path__ + "static/media/H1015.11f3b15b.mp3";